import { render, staticRenderFns } from "./AlarmWorkflowItem.vue?vue&type=template&id=0b7d6e6c&scoped=true"
import script from "./AlarmWorkflowItem.vue?vue&type=script&lang=js"
export * from "./AlarmWorkflowItem.vue?vue&type=script&lang=js"
import style0 from "./AlarmWorkflowItem.vue?vue&type=style&index=0&id=0b7d6e6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d6e6c",
  null
  
)

export default component.exports